import React from 'react';
import { Check } from 'lucide-react';
export function CADVisualization() {
  return <div className="flex flex-col w-full bg-slate-50 rounded-2xl border border-slate-200 shadow-sm overflow-hidden h-full" data-id="element-1">
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col p-4 lg:p-6" data-id="element-2">
        {/* Hero Image Frame */}
        <div className="relative w-full aspect-[4/3] lg:aspect-[5/4] bg-gradient-to-b from-slate-50 to-white rounded-xl shadow-[0_18px_40px_rgba(15,23,42,0.06)] overflow-hidden mb-4 flex items-center justify-center p-6 border border-slate-100" data-id="element-3">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cYLN8naG7Tcx1rNmDvv6v8/Gemini_Generated_Image_902az902az902az9.png" alt="CAD Turbine Model" className="w-full h-full object-contain" data-id="element-4" />
        </div>

        {/* CAD Properties Section - Horizontal Layout */}
        <div className="flex flex-col gap-3 mb-2" data-id="element-5">
          <div className="text-[11px] font-medium tracking-wider text-slate-500 uppercase font-sans" data-id="element-6">
            CAD Properties
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-7">
            {/* Property 1: Part Number */}
            <div className="flex flex-col gap-2" data-id="element-8">
              <span className="text-[12px] font-medium text-slate-500" data-id="element-9">
                Part Number
              </span>
              <div className="flex items-center gap-2" data-id="element-10">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-600 flex-shrink-0" data-id="element-11" />
                <span className="text-[14px] font-semibold text-slate-900" data-id="element-12">
                  BRK-2847-A
                </span>
              </div>
            </div>

            {/* Property 2: Material */}
            <div className="flex flex-col gap-2" data-id="element-13">
              <span className="text-[12px] font-medium text-slate-500" data-id="element-14">
                Material
              </span>
              <div className="flex items-center gap-2" data-id="element-15">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-600 flex-shrink-0" data-id="element-16" />
                <span className="text-[14px] font-semibold text-slate-900" data-id="element-17">
                  Aluminum 6061
                </span>
              </div>
            </div>

            {/* Property 3: Dimensions */}
            <div className="flex flex-col gap-2" data-id="element-18">
              <span className="text-[12px] font-medium text-slate-500" data-id="element-19">
                Dimensions
              </span>
              <div className="flex items-center gap-2" data-id="element-20">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-600 flex-shrink-0" data-id="element-21" />
                <span className="text-[14px] font-semibold text-slate-900" data-id="element-22">
                  150 × 80 × 25mm
                </span>
              </div>
            </div>

            {/* Property 4: Weight */}
            <div className="flex flex-col gap-2" data-id="element-23">
              <span className="text-[12px] font-medium text-slate-500" data-id="element-24">
                Weight
              </span>
              <div className="flex items-center gap-2" data-id="element-25">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-600 flex-shrink-0" data-id="element-26" />
                <span className="text-[14px] font-semibold text-slate-900" data-id="element-27">
                  0.45 kg
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Status Bar - Sticky Bottom */}
      <div className="mt-auto h-11 bg-cyan-500 flex items-center px-4 lg:px-6 gap-2 text-white text-[13px] font-medium w-full" data-id="element-28">
        <Check className="w-4 h-4 text-white/90" data-id="element-29" />
        <span data-id="element-30">Real-time sync active</span>
        <span className="text-cyan-200 mx-1" data-id="element-31">•</span>
        <span className="opacity-90" data-id="element-32">Last updated 2 seconds ago</span>
      </div>
    </div>;
}